import { render } from "./high-end-class.vue?vue&type=template&id=626654be&scoped=true"
import script from "./high-end-class.vue?vue&type=script&lang=js"
export * from "./high-end-class.vue?vue&type=script&lang=js"

import "./high-end-class.vue?vue&type=style&index=0&id=626654be&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-626654be"]])

export default __exports__